// Typography configuration following requirements:
// - Roboto Light for headings
// - Roboto Regular for body text
export const typography = {
  // Base font family for all text
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',

  // Headings use Roboto Light (300 weight)
  h1: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 300,
    fontSize: "2.5rem",
    lineHeight: 1.2,
    letterSpacing: "-0.01562em",
  },
  h2: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 300,
    fontSize: "2rem",
    lineHeight: 1.3,
    letterSpacing: "-0.00833em",
  },
  h3: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 300,
    fontSize: "1.75rem",
    lineHeight: 1.4,
    letterSpacing: "0em",
  },
  h4: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 300,
    fontSize: "1.5rem",
    lineHeight: 1.4,
    letterSpacing: "0.00735em",
  },
  h5: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 300,
    fontSize: "1.25rem",
    lineHeight: 1.5,
    letterSpacing: "0em",
  },
  h6: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 300,
    fontSize: "1.125rem",
    lineHeight: 1.5,
    letterSpacing: "0.0075em",
  },

  // Body text uses Roboto Regular (400 weight)
  body1: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: 1.6,
    letterSpacing: "0.00938em",
  },
  body2: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    fontSize: "0.875rem",
    lineHeight: 1.6,
    letterSpacing: "0.01071em",
  },

  // Additional typography variants
  subtitle1: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    fontSize: "1.125rem",
    lineHeight: 1.5,
    letterSpacing: "0.00938em",
  },
  subtitle2: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 500,
    fontSize: "0.875rem",
    lineHeight: 1.5,
    letterSpacing: "0.00714em",
  },
  caption: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    fontSize: "0.75rem",
    lineHeight: 1.4,
    letterSpacing: "0.03333em",
  },
  button: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 500,
    fontSize: "0.875rem",
    lineHeight: 1.75,
    letterSpacing: "0.02857em",
    textTransform: "uppercase" as const,
  },
} as const;

export default typography;
